import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillClose = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM7.88 9.05C7.58 8.7 7.62 8.17 7.97 7.88C8.28 7.61 8.74 7.61 9.05 7.88L11.85 10.68C11.93 10.76 12.06 10.77 12.14 10.68L14.94 7.87C15.26 7.53 15.8 7.52 16.14 7.85C16.48 8.17 16.49 8.71 16.16 9.05L13.36 11.85C13.28 11.93 13.27 12.06 13.36 12.14L16.16 14.95C16.5 15.26 16.51 15.79 16.2 16.13C16.19 16.14 16.17 16.16 16.16 16.17C16 16.33 15.79 16.41 15.57 16.41C15.35 16.41 15.14 16.32 14.99 16.17L12.19 13.37C12.11 13.29 11.98 13.28 11.9 13.37L9.06 16.18C8.9 16.33 8.7 16.42 8.48 16.42C8.26 16.42 8.05 16.33 7.89 16.18C7.57 15.85 7.57 15.33 7.89 15.01L10.69 12.21C10.77 12.13 10.78 12 10.69 11.92L7.89 9.07L7.88 9.05Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillClose)
